<template>
  <page-view
    :class="`subpage broadcast ${currentTab === '' && broadcast && broadcast.metadata.orientation === 'portrait' ? 'max-heigt' : ''}`"
    :subpage="!!broadcast"
    :title="broadcast ? broadcast.metadata.title : id === 'schedule' ? 'Schedule new broadcast' : ''"
    :id="broadcast ? broadcast.id : ''"
    :longTitle="!!broadcast"
    v-if="state === ''"
    :backLink="backToType"
    backText="Back to Broadcasts"
    :key="$route.hash"
    ref="pageview"
  >
    <template v-slot:below-title v-if="broadcast">
      <div class="start-time">
        <template v-if="['liveStarting', 'live', 'liveStopping'].includes(broadcast.status.life_cycle_status)">
          <pill :class="`live ${broadcast.status.life_cycle_status}`">{{ liveStatus }}</pill>
          <template v-if="['liveStarting'].includes(broadcast.status.life_cycle_status)">
            <i class="icon-clock-fill m-l-2" /> <span>{{ broadcast.scheduled_start_time | formattime }}</span>
          </template>
          <template v-else>
            <span class="m-l-2">{{ liveTime }}</span>
          </template>
        </template>
        <template v-else-if="['complete'].includes(broadcast.status.life_cycle_status)">
          Completed at {{ broadcast.actual_end_time | formattime(false) }}
        </template>
        <template v-else-if="['abandoned', 'error'].includes(broadcast.status.life_cycle_status)">
          <pill>{{ broadcast.status.life_cycle_status }}</pill>
        </template>
        <template v-else>
          <i class="icon-clock-fill" /> <span>{{ broadcast.scheduled_start_time | formattime }}</span>
        </template>
        <template v-if="!['complete', 'abandoned'].includes(lifeCycleStatus) || streamStatus === 'active'">
          <div :class="`stream ${['liveStarting', 'live', 'liveStopping'].includes(lifeCycleStatus) && streamStatus !== 'active' ? 'red' : ''} ${streamStatus === 'active' ? 'green' : ''}`">
            <i :class="`icon-broadcast`" />
            <span>
              <template v-if="['liveStarting', 'live', 'liveStopping'].includes(lifeCycleStatus) && streamStatus !== 'active'">
                Not receiving stream
              </template>
              <template v-else-if="streamStatus === 'active'">
                Receiving stream
              </template>
              <template v-else>
                Inactive stream
              </template>
            </span>
          </div>
        </template>
      </div>
    </template>
    <template v-slot:id>
      <id :id="broadcast.id" v-if="broadcast && broadcast.id" />
    </template>
    <template v-slot:header-right>
      <template v-if="!broadcast">
        <Button :class="`${canSchedule ? '' : 'disable'}`" :loading="scheduling" @click="$refs.general.schedule()">Schedule</Button>
      </template>
      <template v-else-if="broadcast">
        <dots class="border left m-r-2">
          <ul>
            <li @click="deleteBroadcast">
              <i class="icon-close-medium" />
                {{ $t('broadcast.delete_broadcast_text') }}
            </li>
            <a :href="downloadLink" v-if="downloadLink !== ''" target="_blank">
              <i class="icon-expand rotate-90" />
              {{ $t('broadcast.download_source_file') }}
            </a>
            <a :href="`https://${fqdn}.streamify.io/play/broadcast/${id}`" v-if="featuresEnabled.includes('ppv')" target="_blank">
              <i class="icon-eye" />
              View on Play
            </a>
            <template v-if="!featuresEnabled.includes('ppv') && featuresEnabled.includes('lvs')">
              <li v-if="!broadcast.private" @click="togglePrivate(true)">
                <i class="icon-eye-strike-24" />
                  Mark as private
              </li>
              <li v-else @click="togglePrivate(false)">
                <i class="icon-eye-24" />
                  Mark as public
              </li>
            </template>
          </ul>
        </dots>
      </template>
    </template>

    <template v-slot:tabs v-if="broadcast">
      <page-tab icon="stream-24" :active="currentTab === ''" :data-origorder="0" @click.native="handleLink($event, `/broadcast/${broadcast.id}`)" :link="`/broadcast/${broadcast.id}`" :class="`${['live', 'liveStopping'].includes(lifeCycleStatus) || (['liveStarting'].includes(lifeCycleStatus) && !broadcast.actual_start_time.includes('0001-01-01')) ? '' : ''}`">
        <template v-if="['complete'].includes(lifeCycleStatus)">
          Broadcast
        </template>
        <template v-else>
          <!--<pill class="live m-r-1" v-if="['live', 'liveStopping'].includes(lifeCycleStatus) || (['liveStarting'].includes(lifeCycleStatus) && !broadcast.actual_start_time.includes('0001-01-01'))"></pill>--> {{ ['complete'].includes(lifeCycleStatus) ? 'Broadcast' : 'Control center' }}
        </template>
      </page-tab>
      <page-tab title="Settings" :active="currentTab === 'settings'" @click.native="handleLink($event, `/broadcast/${broadcast.id}/settings`)" :link="`/broadcast/${broadcast.id}/settings`" icon="settings-gear-24" />
      <page-tab title="Commerce" :active="currentTab === 'commerce'" @click.native="handleLink($event, `/broadcast/${broadcast.id}/commerce`)" :link="`/broadcast/${broadcast.id}/commerce`" icon="shoppingbag-24"  v-if="broadcast.protected.pay_per_view && ppvEnabled && featuresEnabled.includes('ppv')" />
      <page-tab title="Q&A" :active="currentTab === 'qa'" :data-origorder="5" @click.native="handleLink($event, `/broadcast/${broadcast.id}/qa`)" :link="`/broadcast/${broadcast.id}/qa`" icon="chat-24" v-if="broadcast.event_details.questions.enable" />
      <page-tab title="Statistics" :active="currentTab === 'statistics'" @click.native="handleLink($event, `/broadcast/${broadcast.id}/statistics`)" :link="`/broadcast/${broadcast.id}/statistics`" icon="line-graph-24" />
    </template>
    <template v-if="broadcast">
      <router-view />
    </template>
    <template v-else>
      <general ref="general" @canSchedule="canSchedule = $event" @scheduled="broadcastScheduled" />
    </template>
  </page-view>
</template>

<script>

import moment from 'moment';

import Dots from '@/components/Dots.vue';
import Pill from '@/components/Pill.vue';
import General from '@/routes/Broadcast/General.vue';

export default {
  components: {
    Dots,
    General,
    Pill,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  computed: {
    liveStatus() {
      switch (this.broadcast.status.life_cycle_status) {
        case 'liveStarting':
          if (!this.broadcast.actual_start_time.includes('0001-01-01')) {
            return 'Live';
          }
          return 'Starting';
        case 'live':
          return 'Live';
        case 'liveStopping':
          return 'Stopping';
        default:
          return '';
      }
    },
    /**
     * Return a link that user can use to download broadcast
     * @returns {String}
     */
    downloadLink() {
      if (!this.broadcast || !['complete'].includes(this.broadcast.status.life_cycle_status)) {
        return '';
      }

      return `https://origin.streamify.io/resources/${this.broadcast.id}.mp4?fqdn=${this.longfqdn}`;
    },
    /**
     * Return the current tab
     * @return {String}
     */
    currentTab() {
      const tab = this.$route.path.split('/').pop();
      if (tab === 'schedule') {
        return '';
      }

      if (!this.broadcast) {
        return '';
      }

      return tab === this.broadcast.id ? '' : tab;
    },
    /**
     * Return the current broadcast in store
     * @returns {?Object}
     */
    broadcast() {
      return this.$store.getters['Broadcast/current'];
    },
    /**
     * Return stream string
     * @returns {String}
     */
    streamStatus() {
      return this.broadcast.stream ? this.broadcast.stream.status : '';
    },
    /**
     * Return current life_cycle_status
     * @returns {String}
     */
    lifeCycleStatus() {
      if (!this.broadcast) {
        return '';
      }

      const {
        broadcast: {
          status: {
            life_cycle_status,
          },
        },
      } = this;

      return life_cycle_status;
    },
  },
  methods: {
    /**
     * Toggle isPrivate flag
     * @param {Boolean} bool
     */
    async togglePrivate(bool) {
      await this.$store.dispatch('Broadcast/update', {
        id: this.broadcast.id,
        data: {
          private: bool,
        },
      });
    },
    async broadcastScheduled(id) {
      this.getBroadcast(id);
      this.scheduling = false;
      this.$router.push({ path: `/broadcast/${id}/settings`, replace: true });
    },
    async deleteBroadcast() {
      const willDelete = await swal({
        title: this.$t('errors.are_you_sure'), text: this.$t('broadcast.once_removed'), icon: 'warning', buttons: true, dangerMode: true,
      });

      if (!willDelete) {
        return;
      }

      const doesIt = await this.$store.dispatch('Broadcast/delete', this.id);

      if (!doesIt) {
        swal({ title: this.$t('errors.error_occured'), text: this.$t('broadcast.removed_error'), icon: 'error' });
        return;
      }

      this.$router.push(this.backToType);
    },
    /**
     * Get broadcast and hit updateTimeout function on the next tick
     */
    async getBroadcast(overrideID = null) {
      const id = overrideID || this.id;
      await this.$store.dispatch('Products/listBroadcastProducts', id);
      await this.$store.dispatch('Broadcast/getBroadcast', { id, interval: true });

      this.$nextTick(() => {
        const { broadcast: { status: { life_cycle_status } }, backToType } = this;
        this.$store.dispatch('Events/connect', { id });
        if (backToType === '') {
          const lastRoute = this.$store.getters['Theme/lastRoute'];
          if (lastRoute && lastRoute.path.includes('broadcasts')) {
            this.backToType = lastRoute.fullPath;
          } else {
            switch (life_cycle_status) {
              case 'created':
              case 'ready':
              case 'testStarting':
              case 'testing':
              case 'testStopping':
              case 'liveStarting':
                this.backToType = '/broadcasts/upcoming';
                break;
              case 'complete':
                this.backToType = '/broadcasts/past';
                break;
              case 'abandoned':
                this.backToType = '/broadcasts/abandoned';
                break;
              default:
                this.backToType = '/broadcasts/all';
            }
          }
        }
      });
    },
    timeupdate() {
      if (!this.broadcast) {
        this.liveTime = '';
      }

      const {
        broadcast: {
          actual_start_time,
        },
      } = this;

      const duration = moment.duration(Math.abs(new Date() - new Date(actual_start_time)), 'millisecond');
      const hours = Math.floor(duration.asHours()) >= 10 ? Math.floor(duration.asHours()) : `0${Math.floor(duration.asHours())}`;
      const minutes = Math.floor(duration.minutes()) >= 10 ? Math.floor(duration.minutes()) : `0${Math.floor(duration.minutes())}`;
      const seconds = Math.floor(duration.seconds()) >= 10 ? Math.floor(duration.seconds()) : `0${Math.floor(duration.seconds())}`;
      this.liveTime = `${hours}:${minutes}:${seconds}`;
    },
  },
  data() {
    return {
      state: 'loading',
      canSchedule: true,
      scheduling: false,
      broadcastTimer: null,
      timeInterval: null,
      liveTime: '',
      backToType: '',
    };
  },
  watch: {
    broadcast: {
      immediate: true,
      handler(a, b) {
        if (!a) {
          clearTimeout(this.broadcastTimer);
        }

        if (a && b && b.id !== a.id) {
          this.$store.dispatch('Events/close', b.id);
        }
      },
    },
    lifeCycleStatus: {
      immediate: true,
      handler(status) {
        clearInterval(this.timeInterval);

        if (['live', 'liveStopping'].includes(status)) {
          this.timeupdate();
          this.timeInterval = setInterval(this.timeupdate, 1000);
        }
      },
    },
  },
  async mounted() {
    clearTimeout(this.broadcastTimer);
    await this.$store.dispatch('Broadcast/unsetBroadcast');

    if (this.id !== 'schedule') {
      await this.getBroadcast();
    } else {
      const lastRoute = this.$store.getters['Theme/lastRoute'];
      if (lastRoute && lastRoute.path.includes('broadcasts')) {
        this.backToType = lastRoute.fullPath;
      } else {
        this.backToType = '/broadcasts';
      }
    }

    this.state = '';
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
    this.$store.dispatch('Events/close', this.id);
    this.$store.commit('Products/setBroadcastList', []);
    this.$store.dispatch('Broadcast/unsetBroadcast');
    this.$store.commit('Products/clearEventProducts');
  },
  filters: {
    formattime: (date, humanize = true) => (humanize ? moment(date).fromNow() : moment(date).format('YYYY-MM-DD HH:mm')),
  },
};
</script>

<style lang="scss">
.broadcast {
  header {
    .dots {
      .dropper {
        ul > * {
          padding: 10px;
        }
      }
    }

    .start-time {
      display: flex;
      align-items: center;
      color: #868B97;
      font-size: 16px;
      margin-top: 5px;
      white-space: nowrap;

      i {
        font-size: 18px;
        margin-right: 3px;
      }
    }
  }

  .stream {
    align-items: center;
    display: flex;
    margin-left: 10px;

    &.red {
      i {
        color: var(--color-cta-red);
      }
    }
    &.green {
      i {
        color: var(--color-cta-green);
      }
    }
  }
}
</style>
